import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Tooltip from '@material-ui/core/Tooltip';
import InputBase from '@material-ui/core/InputBase';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles(theme => ({
    input: {
        border: '1px solid rgba(0, 0, 0, 0.23)',
        minWidth: 'auto',

        '& input': {
            textAlign: 'center',
            width: 44
        }
    }
}));

const key = 'FONTSIZE_';

export default function Fontsize(props) {

    const classes = useStyles();
    const { editorState, onToggle, editorFocus } = props;
    const styleNames = editorState.getCurrentInlineStyle();

    const [ fontSize, setFontSize ] = useState(14);

    useEffect(() => {
        const newFontSize = styleNames.find(style => style.startsWith(key))?.split(key)[1];

        setFontSize(parseInt(newFontSize) || 14);
    }, [styleNames]);

    const decreaseFontSize = (event) => {
        event.preventDefault();
        onToggle(fontSize - 1, key);
    }

    const increaseFontSize = (event) => {
        event.preventDefault();
        onToggle(fontSize + 1, key);
    }

    const updateFontSize = (event) => {
        event.preventDefault();
        setFontSize(parseInt(event.target.value) || '');
    }

    const toggleFontSize = (event) => {
        event.preventDefault();
        onToggle(fontSize, key);
        editorFocus();
    }

    return (
        <ButtonGroup>
            <Tooltip title="Decrease Font Size">
                <Button
                    size="small"
                    onMouseDown={(event) => decreaseFontSize(event)}
                    >
                    <RemoveIcon size="small"/>
                </Button>
            </Tooltip>
            <Tooltip title="Increase Font Size">
                <InputBase
                    value={fontSize}
                    onChange={updateFontSize}
                    className={classes.input}
                    onBlur={toggleFontSize}
                    color="primary"
                    onFocus={(e) => e.target.select()}
                />
            </Tooltip>
            <Tooltip title="Increase Font Size">
                <Button
                    size="small"
                    onMouseDown={(event) => increaseFontSize(event)}
                    >
                    <AddIcon size="small"/>
                </Button>
            </Tooltip>
        </ButtonGroup>
    );
}
